export default {
  // Navigation
  nav_home: 'ទំព័រដើម',
  nav_about: 'អំពីយើង',
  nav_profile: 'ប្រវត្តិក្រុមហ៊ុន',
  nav_business: 'ពាណិជ្ជកម្ម',
  nav_contact: 'ទំនាក់ទំនង',

  // Language Switcher
  lang_en: 'English',
  lang_ja: '日本語',
  lang_km: 'ខ្មែរ',

  // Hero
  hero_line1: 'ភ្ជាប់ប្រទេសកម្ពុជា និងជប៉ុន',
  hero_line2: 'តាមរយៈទំនុកចិត្ត ពាណិជ្ជកម្ម និងតម្លៃ។',
  hero_desc: 'LAVSTYLE (CAMBODIA) INTERNATIONAL CO., LTD. គឺជាក្រុមហ៊ុនអន្តរជាតិ ដែលមានមូលដ្ឋាននៅកម្ពុជា បង្កើតឡើងជាមួយដៃគូជប៉ុន។ យើងផ្តល់ជូននូវដំណោះស្រាយពាណិជ្ជកម្មដែលអាចទុកចិត្តបាន នៅក្នុងឧស្សាហកម្មជាច្រើន ដោយសង់ស្ពានរវាងពិភពលោកទាំងសងខាង។',

  // About
  about_label: 'អំពីយើង',
  about_title: 'ស្ពានរវាងកម្ពុជា និងជប៉ុន',
  about_desc: 'LAVSTYLE (CAMBODIA) INTERNATIONAL CO., LTD. ត្រូវបានបង្កើតឡើងនៅប្រទេសកម្ពុជា តាមរយៈកិច្ចសហប្រតិបត្តិការជាមួយក្រុមហ៊ុនជប៉ុនដែលមានកិត្តិយស។ ជាក្រុមហ៊ុនអន្តរជាតិ យើងធ្វើការជាមួយរចនាសម្ព័ន្ធពាណិជ្ជកម្មដែលស្អាត និងអាចទុកចិត្តបាន និងបម្រើជាចំណុចតភ្ជាប់ដែលអាចទុកចិត្តបាន សម្រាប់ពាណិជ្ជកម្មឆ្លងព្រំដែនរវាងកម្ពុជា និងជប៉ុន។ ការបោះជំហានរបស់យើងក្នុងភាពវិជ្ជាជីវៈ ភាពមិនលាក់លៀស និងភាពអស្ចារ្យ គឺជាចលនាពីព្រោះអ្វីៗទាំងអស់ដែលយើងធ្វើ។',

  // Company Profile
  profile_label: 'ប្រវត្តិក្រុមហ៊ុន',
  profile_company: 'ឈ្មោះក្រុមហ៊ុន',
  profile_address: 'អាស័យដ្ឋាន',
  profile_phone: 'ទូរស័ព្ទ',
  profile_email: 'អ៊ីមែល',
  profile_related: 'ក្រុមហ៊ុនជប៉ុនដែលពាក់ព័ន្ធ',

  // Partnership
  partner_label: 'កិច្ចសហប្រតិបត្តិការជាមួយជប៉ុន',
  partner_title: 'បង្កើតឡើងដោយទំនុកចិត្ត',
  partner_subtitle: 'កិច្ចសហប្រតិបត្តិការកម្ពុជា-ជប៉ុន',
  partner_desc: 'ក្រុមហ៊ុនរបស់យើងត្រូវបានបង្កើតឡើងដោយជាមួយក្រុមហ៊ុនជប៉ុន ដែលមានជំនាញជ្រៅក្នុងវិស័យរបស់ពួកគេ។ កិច្ចសហប្រតិបត្តិការនេះបង្រួមភាពត្រឹមត្រូវរបស់ជប៉ុន ស្តង់ដារគុណភាព និងទស្សនវិស័យពាណិជ្ជកម្ម ជាមួយទីផ្សារដែលមានថាមពលរបស់កម្ពុជា និងសក្តានុពលកំណើន។ ជាមួយគ្នា យើងបង្កើតតម្លៃយូរអង្វែងសម្រាប់ដៃគូ និងអតិថិជនរបស់យើង។',
  partner_1: 'LAV CO., LTD.',
  partner_2: 'IDO Corporation',
  partner_3: 'SWEEP Fukuoka',

  // Business
  business_label: 'ពាណិជ្ជកម្មរបស់យើង',
  business_desc: 'យើងប្រតិបត្តិការនៅក្នុងវិស័យពាណិជ្ជកម្មជាច្រើន ដោយបង្កើតតម្លៃតាមរយៈសេវាកម្មវិជ្ជាជីវៈ និងស្តង់ដារអន្តរជាតិ។',

  business_1_en: 'Restaurants and late-night food and beverage establishments',
  business_1_ja: 'レストランおよび深夜営業の飲食店',
  business_1_km: 'ភោជនីយដ្ឋាន និង​កន្លែង​លក់​អាហារ និង​ភេសជ្ជៈ​សម្រាប់​ពេល​យប់​ជ្រៅ',

  business_2_en: 'Wholesale and retail of various goods',
  business_2_ja: '各種商品の卸売・小売',
  business_2_km: 'លក់ដុំ និងលក់រាយទំនិញជាច្រើនប្រភេទ',

  business_3_en: 'General construction work; Contracting and agency for various construction works',
  business_3_ja: '一般建設工事、各種建設工事の請負及び代理',
  business_3_km: 'ការងារសំណង់ទូទៅ; ការចុះកិច្ចសន្យា និងភ្នាក់ងារសម្រាប់ការងារសំណង់ផ្សេងៗ',

  business_4_en: 'Cleaning, maintenance, and management of buildings',
  business_4_ja: '建物の清掃、保守、管理',
  business_4_km: 'ការសម្អាត ការថែទាំ និង ការគ្រប់គ្រងអគារ',

  business_5_en: 'Collection and transportation of industrial waste',
  business_5_ja: '産業廃棄物の収集・運搬',
  business_5_km: 'ការប្រមូល និងដឹកជញ្ជូនកាកសំណល់ឧស្សាហកម្ម',

  business_6_en: 'Human resources provision',
  business_6_ja: '人材提供',
  business_6_km: 'ការផ្គត់ផ្គង់ធនធានមនុស្ស',

  business_7_en: 'E-commerce and online information services',
  business_7_ja: '電子商取引およびオンライン情報サービス',
  business_7_km: 'សេវាកម្មព័ត៌មានអនឡាញ និងពាណិជ្ជកម្មអេឡិចត្រូនិក',

  // Strengths
  strengths_label: 'ហេតុអ្វីជ្រើសរើសយើង',
  strengths_title: 'ចំណុចខ្លាំងរបស់យើង',
  strength_1_title: 'កិច្ចសហប្រតិបត្តិការអន្តរជាតិ',
  strength_1_desc: 'បង្កើតឡើងដោយក្រុមហ៊ុនជប៉ុន យើងនាំយកស្តង់ដារអន្តរជាតិ និងជំនាញឆ្លងព្រំដែនទៅក្នុងគម្រោងទាំងអស់។',
  strength_2_title: 'សមត្ថភាពពាណិជ្ជកម្មច្រើនវិស័យ',
  strength_2_desc: 'ការវិនិយោគទុនដែលមានភាពចម្រុះរបស់យើងគ្របដណ្តប់លើសំណង់ សេវាកម្មអាហារ លក់រាយ សម្អាត គ្រប់គ្រងកាកសំណល់ ធនធានមនុស្ស និងសេវាឌីជីថល។',
  strength_3_title: 'ស្ពានកម្ពុជា-ជប៉ុន',
  strength_3_desc: 'យើងបម្រើជាចំណុចតភ្ជាប់ដែលអាចទុកចិត្តបាន សម្រាប់ក្រុមហ៊ុនដែលចង់ប្រតិបត្តិការរវាងកម្ពុជា និងជប៉ុន។',
  strength_4_title: 'រចនាសម្ព័ន្ធដែលអាចទុកចិត្តបាន',
  strength_4_desc: 'ការគ្រប់គ្រងក្រុមហ៊ុនដែលស្អាត ប្រតិបត្តិការដែលមានតម្លាភាព និងការប្តេជ្ញាចិត្តចំពោះការអនុវត្តពាណិជ្ជកម្មដោយសីលធម៌។',
  strength_5_title: 'ការគាំទ្រដែលបត់បែន',
  strength_5_desc: 'យើងសម្រួលសេវាកម្មរបស់យើង ដើម្បីបំពេញតម្រូវការពិសេសរបស់អតិថិជននៅក្នុងវិស័យ និងទំហំផ្សេងៗគ្នា។',

  // Contact
  contact_label: 'ទំនាក់ទំនង',
  contact_title: 'ទំនាក់ទំនងយើង',
  contact_desc: 'យើងស្វាគមន៍ការសួររក និងកិច្ចសហប្រតិបត្តិការ។ សូមទាក់ទងមកយើងសម្រាប់ការពិភាក្សាពាណិជ្ជកម្ម ឬកិច្ចសហប្រតិបត្តិការណាមួយ។',
  contact_email_label: 'អ៊ីមែល',
  contact_phone_label: 'ទូរស័ព្ទ',
  contact_guidance: 'សូមទាក់ទងយើងតាមរយៈអ៊ីមែល។ យើងមានគោលបំណងឆ្លើយតបក្នុងរយៈពេល ២ ថ្ងៃធ្វើការ។',

  // Footer
  footer_company: 'LAVSTYLE (CAMBODIA) INTERNATIONAL CO., LTD.',
  footer_tagline: 'ភ្ជាប់ប្រទេសកម្ពុជា និងជប៉ុនតាមរយៈទំនុកចិត្ត និងតម្លៃ។',
  partner_1_url: 'http://www.lavgroup.biz/',
  partner_2_url: 'https://ido-corp.jp/',
  partner_3_url: 'https://sweep-sue.com/',

  // Footer
  footer_links: 'តំណភ្ជាប់រហ័ស',
  footer_contact: 'ព័ត៌មានទំនាក់ទំនង',
  footer_location: 'ទីតាំង',
  footer_copyright: '© 2025 LAVSTYLE (CAMBODIA) INTERNATIONAL CO., LTD. រក្សាសិទ្ធិគ្រប់យ៉ាង។',
  footer_privacy: 'គោលការភាពឯកជន',
  footer_terms: 'ល័ក្ខខណ្ឌប្រើប្រាស់',
};